module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEXSURBVEhL3dM9SgRBEMXxwQsopoJiYGSqlzEx8AAbGngGbyFiIkYGfoQaiuwZTA0EEdRE/w8teDTdNT1otA9+zOzUTFXP9u6wsNnADV5/j+v419ziy2hIlnvc/Zz2RSv3AfqcJe7rTvkGV8gyeYC+82to5TqO7cGkAau4wDv00Ac0ZA2tTBpwinjAZRsd94xmBbHymk3UEvXR7MMblg5RS9RHcwlvWHpALVFPo839hDes2UKZqKU5gDdqOUKZqKXRT9EbtcxRJmpptnECb1bSP3oHkT28Ieo617VmjuENS+fw1N5a15p5RPmAe8YS/pwXqOFyce7ZhQ93qqXpGTCDN3WqpekZcAZv6lRL0zPgCd7UqbYQGYZvR5O6NU9/hDAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-housekeeper/dark/24.png
// module id = 2166
// module chunks = 2